"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _createStore = _interopRequireDefault(require("./createStore"));

var ReduxContainer = function ReduxContainer(props) {
  var reducers = props.reducers,
      middlewares = props.middlewares,
      children = props.children;
  var store = (0, _react.useMemo)(function () {
    return (0, _createStore["default"])(reducers, middlewares);
  }, [reducers, middlewares]);
  return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: store
  }, children);
};

ReduxContainer.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object]),
  reducers: _propTypes["default"].object,
  middlewares: _propTypes["default"].array
};
ReduxContainer.defaultProps = {
  children: null,
  reducers: {},
  middlewares: []
};
var _default = ReduxContainer;
exports["default"] = _default;